import { render } from "./store-details.vue?vue&type=template&id=663a78bc"
import script from "./store-details.vue?vue&type=script&setup=true&lang=js"
export * from "./store-details.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/odoo/store-details.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "663a78bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('663a78bc', __exports__)) {
    console.log('reload')
    api.reload('663a78bc', __exports__)
  }
  
  module.hot.accept("./store-details.vue?vue&type=template&id=663a78bc", () => {
    console.log('re-render')
    api.rerender('663a78bc', render)
  })

}


export default __exports__